<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="monthPassName"
                placeholder="monthPassName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="price"
                placeholder="price"
                type="number"
                :fieldValue.sync="formData.price"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                prefix="HK$"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.schools"
                :options="tutorSchoolOptions"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                isMultiple
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
              <v-radio-group
                name="monthPackageType"
                v-model="formData.type"
                row
                :readonly="$store.getters.isLoading"
                class="mt-0"
              >
                <v-radio :label="$t('monthPassTypeOption.days')" value="days"></v-radio>
                <v-radio :label="$t('monthPassTypeOption.months')" value="months"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" class="pt-0">
              <small class="d-block text-caption colorBlack--text">{{ $t('typeDurationDes') }}</small>
              <small class="d-block text-caption colorBlack--text">{{ $t('typeByMonthDes') }}</small>
            </v-col>
          </v-row>
          <v-row class="ma-0" v-if="formData.type === 'days'">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="monthPassValidDay"
                placeholder="monthPassValidDay"
                :fieldValue.sync="formData.days"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
                :options="startDateOptions"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'MonthPassDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
    FormSelect,
  },
  computed: {
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    formData: {
      name: '',
      price: '',
      type: 'days', // 'days' | 'months'
      days: null,
      schools: [],
    },

    startDateOptions: [],
    tutorSchoolOptions: [],
  }),
  methods: {
    async getMonthPassById() {
      try {
        const data = await this.$Fetcher.GetMonthPassById(this.id)
        // staff只可以view所屬分校package
        if (this.$validate.DataValid(data.schools, true)) {
          let pass = false
          const getUserSchools = this.gfGetUserSchools()
          for (let i = 0; i < data.schools.length; i++) {
            if (getUserSchools.includes(data.schools[i])) {
              pass = true
              break
            }
          }
          if (!pass) {
            this.permissionValid = false
            throw 'message.notBelongMonthPassBranch'
          }
        }

        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        let isAllSchool = true
        for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
          if (this.tutorSchoolOptions[i].value !== -1) {
            const found = this.formData.schools.find(el => el === this.tutorSchoolOptions[i].value)
            if (!found) {
              isAllSchool = false
              break
            }
          }
        }
        if (isAllSchool) {
          this.formData.schools.push(-1)
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'MonthPassList',
          })
        }
      }
    },

    // -- (確認)
    async save() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const payload = {
          name: this.formData.name,
          price: parseFloat(this.formData.price),
          type: this.formData.type,
          days: this.formData.days,
          schools: this.formData.schools.filter(el => el !== -1),
        }

        let message = {}
        if (this.$validate.DataValid(this.id)) {
          await this.$Fetcher.UpdateMonthPass(this.id, payload)
          message = {
            message: 'message.saveSuccess',
            refresh: true,
          }
        } else {
          await this.$Fetcher.NewMonthPass(payload)
          message = {
            message: 'message.createSuccess',
            redirect: 'MonthPassList',
          }
        }
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          ...message,
          type: 'success',
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: this.$validate.DataValid(this.id) ? 'message.saveFail' : 'message.createFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirmRef = this.getConfirmDialogRef()
      const confirm = await confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          await this.$Fetcher.DeleteMonthPass(this.id)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'MonthPassList',
          })
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    // ======== 分校 Options =======
    async _getTutorSchoolOptions() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.tutorSchoolOptions = filtered.map(el => {
            return { value: el.id, text: el.name }
          })

          let disabledAll = false
          const getUserSchools = this.gfGetUserSchools()
          if (this.$validate.DataValid(this.id)) {
            // when edit，不屬於staff的分校會disabled
            this.tutorSchoolOptions = this.tutorSchoolOptions.map(el => {
              const disabled = !getUserSchools.includes(el.value)
              if (disabled) {
                disabledAll = true
              }
              return {
                ...el,
                disabled: disabled,
              }
            })
          } else {
            // When create，只會攞staff所屬嘅分校
            this.tutorSchoolOptions = this.tutorSchoolOptions.filter(el => getUserSchools.includes(el.value))
          }

          this.tutorSchoolOptions.unshift({
            value: -1,
            text: this.$t('allCenters'),
            disabled: disabledAll,
          })
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: MonthPassDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      await this._getTutorSchoolOptions()
      if (this.$validate.DataValid(this.id)) {
        // edit
        await this.getMonthPassById()
      }
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  created() {
    this.startDateOptions = []
    for (let i = 15; i <= 31; i++) {
      this.startDateOptions.push({ value: i, text: `${i}${this.$t('day')}` })
    }
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
